<template>
  <section class="mt-10">
    <nav
      aria-label="Breadcrumb"
      class="flex"
    >
      <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
        <li class="inline-flex items-center">
          <a
            class="inline-flex items-center text-sm font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white"
            href="#"
          >Admin</a>
        </li>
        <li>
          <div class="flex items-center">
            <svg
              aria-hidden="true"
              class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
              fill="none"
              viewBox="0 0 6 10"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m1 9 4-4-4-4"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
            <a
              class="ms-1 text-sm font-medium text-black hover:text-primary md:ms-2 dark:text-white dark:hover:text-white"
              href="#"
            >Courses</a>
          </div>
        </li>
      </ol>
    </nav>
    <div class="relative bg-white shadow-md dark:bg-gray-800 sm:rounded-lg mt-6">
      <div
        class="flex flex-col items-center justify-between py-4 mx-4 space-y-3 border-b md:flex-row md:space-y-0 md:space-x-4 dark:border-gray-700"
      >
        <div class="flex items-center w-full space-x-3">
          <h5 class="font-semibold dark:text-white">
            {{ course.title }}
          </h5>
          <div
            v-if="course.modules"
            class="font-medium text-gray-500 dark:text-gray-400"
          >
            {{ course.modules.length }}
            modules.
          </div>
          <div data-tooltip-target="results-tooltip">
            <svg
              aria-hidden="true"
              class="w-4 h-4 text-gray-500 dark:text-gray-400"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                fill-rule="evenodd"
              />
            </svg>
            <span class="sr-only">More info</span>
          </div>
          <div
            id="results-tooltip"
            class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700"
            role="tooltip"
          >
            Showing 1-10 of 6,560 results
            <div
              class="tooltip-arrow"
              data-popper-arrow
            />
          </div>
        </div>
        <div class="flex flex-row items-center justify-end w-full space-x-3">
          <button
            class="flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-white rounded-lg md:w-auto bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
            type="button"
            @click="openModal('newModule')"
          >
            <svg
              aria-hidden="true"
              class="h-3.5 w-3.5 mr-2"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                fill-rule="evenodd"
              />
            </svg>
            <span>New Module</span>
          </button>
          <Modal
            :is-visible="modals.newModule"
            modal-id="newModule"
            @update:is-visible="value => modals.newModule = value"
          >
            <template #body>
              <div class="p-4">
                <div class="flex flex-col items-center justify-center">
                  <svg
                    class="w-52"
                    fill="none"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      id="SVGRepo_bgCarrier"
                      stroke-width="0"
                    />
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M12.5518 8C11.9995 8 11.5518 8.44772 11.5518 9C11.5518 9.55228 11.9995 10 12.5518 10H16.5518C17.104 10 17.5518 9.55228 17.5518 9C17.5518 8.44772 17.104 8 16.5518 8H12.5518Z"
                        fill="#000000"
                        fill-opacity="0.5"
                      />
                      <path
                        d="M12.5518 17C11.9995 17 11.5518 17.4477 11.5518 18C11.5518 18.5523 11.9995 19 12.5518 19H16.5518C17.104 19 17.5518 18.5523 17.5518 18C17.5518 17.4477 17.104 17 16.5518 17H12.5518Z"
                        fill="#000000"
                        fill-opacity="0.5"
                      />
                      <path
                        d="M12.5518 5C11.9995 5 11.5518 5.44772 11.5518 6C11.5518 6.55228 11.9995 7 12.5518 7H20.5518C21.104 7 21.5518 6.55228 21.5518 6C21.5518 5.44772 21.104 5 20.5518 5H12.5518Z"
                        fill="#000000"
                        fill-opacity="0.8"
                      />
                      <path
                        d="M12.5518 14C11.9995 14 11.5518 14.4477 11.5518 15C11.5518 15.5523 11.9995 16 12.5518 16H20.5518C21.104 16 21.5518 15.5523 21.5518 15C21.5518 14.4477 21.104 14 20.5518 14H12.5518Z"
                        fill="#000000"
                        fill-opacity="0.8"
                      />
                      <path
                        d="M3.44824 4.00208C2.89596 4.00208 2.44824 4.44979 2.44824 5.00208V10.0021C2.44824 10.5544 2.89596 11.0021 3.44824 11.0021H8.44824C9.00053 11.0021 9.44824 10.5544 9.44824 10.0021V5.00208C9.44824 4.44979 9.00053 4.00208 8.44824 4.00208H3.44824Z"
                        fill="#000000"
                      />
                      <path
                        d="M3.44824 12.9979C2.89596 12.9979 2.44824 13.4456 2.44824 13.9979V18.9979C2.44824 19.5502 2.89596 19.9979 3.44824 19.9979H8.44824C9.00053 19.9979 9.44824 19.5502 9.44824 18.9979V13.9979C9.44824 13.4456 9.00053 12.9979 8.44824 12.9979H3.44824Z"
                        fill="#000000"
                      />
                    </g>
                  </svg>
                  <h2 class="block text-2xl font-bold text-gray-800 dark:text-gray-200">
                    Create New Module
                  </h2>
                  <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
                    You are creating a new module for this course.
                  </p>
                </div>
                <div class="relative mt-6">
                  <input
                    id="newModuleTitle"
                    v-model="newModule.title"
                    class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2"
                    placeholder="Enter the module name"
                    type="text"
                  >
                  <label
                    class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500"
                    for="newModuleTitle"
                  >Module
                    name</label>
                </div>
                <div class="relative mt-4 mb-2">
                  <textarea
                    v-model="newModule.description"
                    class="py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                    placeholder="Please describe this module..."
                    rows="3"
                  />
                </div>
              </div>
            </template>
            <template #footer>
              <div class="flex items-center">
                <button
                  class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                  type="button"
                  @click="closeModal('newModule')"
                >
                  Cancel
                </button>
                <button
                  class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                  type="button"
                  @click="createModule"
                >
                  Create
                </button>
              </div>
            </template>
          </Modal>
        </div>
      </div>
      <draggable
        v-model="course.modules"
        class="draggable-items"
        @change="orderModules"
      >
        <div
          v-for="(module, index) in course.modules"
          id="draggable-course-module-accordion"
          :key="index"
          class="p-4 border-t bg-white drag-item border-gray-200"
        >
          <div
            :id="'accordion-flush-heading-' + index"
            class="cursor-pointer"
            @click="toggleModule(module)"
          >
            <div class="flex justify-between items-center w-full font-medium text-left text-gray-900 dark:text-white">
              <div class="flex justify-between items-center w-full">
                <div class="flex">
                  <svg
                    class="w-auto mr-1 h-6 float-right rotate-180 fill-gray-300 shrink-0"
                    fill="none"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      id="SVGRepo_bgCarrier"
                      stroke-width="0"
                    />
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M16 17C17.1046 17 18 17.8954 18 19C18 20.1046 17.1046 21 16 21C14.8954 21 14 20.1046 14 19C14 17.8954 14.8954 17 16 17ZM8 17C9.10457 17 10 17.8954 10 19C10 20.1046 9.10457 21 8 21C6.89543 21 6 20.1046 6 19C6 17.8954 6.89543 17 8 17ZM16 10C17.1046 10 18 10.8954 18 12C18 13.1046 17.1046 14 16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10ZM8 10C9.10457 10 10 10.8954 10 12C10 13.1046 9.10457 14 8 14C6.89543 14 6 13.1046 6 12C6 10.8954 6.89543 10 8 10ZM16 3C17.1046 3 18 3.89543 18 5C18 6.10457 17.1046 7 16 7C14.8954 7 14 6.10457 14 5C14 3.89543 14.8954 3 16 3ZM8 3C9.10457 3 10 3.89543 10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5C6 3.89543 6.89543 3 8 3Z"
                      />
                    </g>
                  </svg>
                  <h2 class="">
                    {{ module.title }}
                  </h2>
                </div>
                <div class="flex items-center">
                  <span class="text-sm text-gray-400 mr-4">{{
                    getContentCount(module)
                  }}</span>
                  <svg
                    v-if="module.show"
                    class="w-3 h-6 float-right rotate-180 shrink-0"
                    fill="none"
                    height="2"
                    viewBox="0 0 12 2"
                    width="12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.75 1H11.25"
                      stroke="black"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </svg>
                  <svg
                    v-if="!module.show"
                    class="w-3 h-6 float-right rotate-180 shrink-0"
                    fill="none"
                    height="12"
                    viewBox="0 0 12 12"
                    width="12"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 0.75V11.25M0.75 6H11.25"
                      stroke="black"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="module.show"
            :id="'accordion-flush-body-' + index"
            class="mt-3"
          >
            <div class="flex justify-between mt-2 mb-2">
              <span
                class="text-sm text-gray-400 ml-6"
              >Here you can view and manage the module content.</span>
              <div class="flex">
                <button
                  class="flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                  type="button"
                  @click="openUpdateModuleModal(module._id)"
                >
                  <svg
                    class="w-5 h-5 mr-2"
                    fill="#000000"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      id="SVGRepo_bgCarrier"
                      stroke-width="0"
                    />
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <title />
                      <g id="Complete">
                        <g id="edit">
                          <g>
                            <path
                              d="M20,16v4a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V6A2,2,0,0,1,4,4H8"
                              fill="none"
                              stroke="#000000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            />
                            <polygon
                              fill="none"
                              points="12.5 15.8 22 6.2 17.8 2 8.3 11.5 8 16 12.5 15.8"
                              stroke="#000000"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span>Edit Module</span>
                </button>
                <button
                  class="flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-red-500 bg-white border border-red-400 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                  type="button"
                  @click="openDeleteModuleModal(module._id)"
                >
                  <svg
                    class="w-5 h-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g
                      id="SVGRepo_bgCarrier"
                      stroke-width="0"
                    />
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M4 7H20"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                        stroke="#ff5c5c"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>
                  <span>Delete Module</span>
                </button>
              </div>
            </div>
            <div class="p-4 rounded-lg border border-gray-300">
              <div class="relative overflow-hidden bg-white">
                <div class="flex items-center justify-between">
                  <div>
                    <h5 class="mr-3 font-semibold dark:text-white">
                      Contents
                    </h5>
                  </div>
                  <div class="flex flex-row items-center justify-end w-full space-x-3">
                    <button
                      class="flex items-center justify-center w-full px-3 py-2 text-sm font-medium text-white rounded-lg md:w-auto bg-black hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800"
                      type="button"
                      @click="openNewContentModal(module._id)"
                    >
                      <svg
                        aria-hidden="true"
                        class="h-3.5 w-3.5 mr-2"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          clip-rule="evenodd"
                          d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                          fill-rule="evenodd"
                        />
                      </svg>
                      <span>New Content</span>
                    </button>
                  </div>
                </div>
              </div>
              <draggable
                v-model="module.contents"
                @change="orderContents(module)"
              >
                <div
                  v-for="(content, contentIndex) in module.contents"
                  :key="contentIndex"
                  class="content-item flex items-center py-2 bg-white hover:bg-gray-100 cursor-pointer justify-between rounded-lg border border-gray-200 mt-2 pr-2"
                >
                  <div class="flex items-center">
                    <div class="flex items-center mx-1">
                      <svg
                        class="w-auto h-6 float-right rotate-180 fill-gray-300 shrink-0"
                        fill="none"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          id="SVGRepo_bgCarrier"
                          stroke-width="0"
                        />
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M16 17C17.1046 17 18 17.8954 18 19C18 20.1046 17.1046 21 16 21C14.8954 21 14 20.1046 14 19C14 17.8954 14.8954 17 16 17ZM8 17C9.10457 17 10 17.8954 10 19C10 20.1046 9.10457 21 8 21C6.89543 21 6 20.1046 6 19C6 17.8954 6.89543 17 8 17ZM16 10C17.1046 10 18 10.8954 18 12C18 13.1046 17.1046 14 16 14C14.8954 14 14 13.1046 14 12C14 10.8954 14.8954 10 16 10ZM8 10C9.10457 10 10 10.8954 10 12C10 13.1046 9.10457 14 8 14C6.89543 14 6 13.1046 6 12C6 10.8954 6.89543 10 8 10ZM16 3C17.1046 3 18 3.89543 18 5C18 6.10457 17.1046 7 16 7C14.8954 7 14 6.10457 14 5C14 3.89543 14.8954 3 16 3ZM8 3C9.10457 3 10 3.89543 10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5C6 3.89543 6.89543 3 8 3Z"
                          />
                        </g>
                      </svg>
                    </div>
                    <div
                      class="relative mr-3 inline-flex items-center justify-center w-12 h-8 overflow-hidden bg-white dark:bg-gunmetal border-[0.5px] border-gray-200"
                    >
                      <span class="font-medium text-gray-600 dark:text-gray-300"> <svg
                        v-if="content.type === 'video'"
                        class="w-6 h-6 text-gray-800 dark:text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      ><g
                        id="SVGRepo_bgCarrier"
                        stroke-width="0"
                      /><g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      /><g
                        id="SVGRepo_iconCarrier"
                      > <path
                        d="M6 9.32993V14.6699C6 17.9899 8.35 19.3399 11.22 17.6899L12.5 16.9499C12.81 16.7699 13 16.4399 13 16.0799V7.91993C13 7.55993 12.81 7.22993 12.5 7.04993L11.22 6.30992C8.35 4.65992 6 6.00993 6 9.32993Z"
                        fill="#000000"
                      /> <path
                        d="M14 8.79006V15.2201C14 15.6101 14.42 15.8501 14.75 15.6501L15.85 15.0101C18.72 13.3601 18.72 10.6401 15.85 8.99006L14.75 8.35006C14.42 8.16006 14 8.40006 14 8.79006Z"
                        fill="#000000"
                        opacity="0.4"
                      /> </g></svg> <svg
                        v-else-if="content.type === 'article'"
                        class="w-6 h-6 text-gray-800 dark:text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      ><g
                        id="SVGRepo_bgCarrier"
                        stroke-width="0"
                      /><g
                        id="SVGRepo_tracerCarrier"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      /><g
                        id="SVGRepo_iconCarrier"
                      > <path
                        d="M12 5.29994V21.3299C11.83 21.3299 11.65 21.2999 11.51 21.2199L11.47 21.1999C9.55 20.1499 6.2 19.0499 4.03 18.7599L3.74 18.7199C2.78 18.5999 2 17.6999 2 16.7399V4.65994C2 3.46994 2.97 2.56994 4.16 2.66994C6.26 2.83994 9.44 3.89994 11.22 5.00994L11.47 5.15994C11.62 5.24994 11.81 5.29994 12 5.29994Z"
                        fill="#000000"
                        opacity="0.4"
                      /> <path
                        d="M22 4.67003V16.74C22 17.7 21.22 18.6 20.26 18.72L19.93 18.76C17.75 19.05 14.39 20.16 12.47 21.22C12.34 21.3 12.18 21.33 12 21.33V5.30003C12.19 5.30003 12.38 5.25003 12.53 5.16003L12.7 5.05003C14.48 3.93003 17.67 2.86003 19.77 2.68003H19.83C21.02 2.58003 22 3.47003 22 4.67003Z"
                        fill="#000000"
                      /> <path
                        d="M7.75 9.23999H5.5C5.09 9.23999 4.75 8.89999 4.75 8.48999C4.75 8.07999 5.09 7.73999 5.5 7.73999H7.75C8.16 7.73999 8.5 8.07999 8.5 8.48999C8.5 8.89999 8.16 9.23999 7.75 9.23999Z"
                        fill="#000000"
                      /> <path
                        d="M8.5 12.24H5.5C5.09 12.24 4.75 11.9 4.75 11.49C4.75 11.08 5.09 10.74 5.5 10.74H8.5C8.91 10.74 9.25 11.08 9.25 11.49C9.25 11.9 8.91 12.24 8.5 12.24Z"
                        fill="#000000"
                      /> </g></svg></span>
                    </div>
                    <h2 class="text-black dark:text-white text-1xl">
                      {{ content.title }}
                    </h2>
                  </div>
                  <div class="flex items-center">
                    <span class="text-xs text-graphite dark:text-off-white">{{ content.length }} dakika</span>
                    <button
                      class="flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-black bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-gray-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                      type="button"
                      @click="openDeleteContentModal(content._id)"
                    >
                      <svg
                        class="w-5 h-5"
                        fill="none"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          id="SVGRepo_bgCarrier"
                          stroke-width="0"
                        />
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M4 7H20"
                            stroke="#000000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                          <path
                            d="M6 10L7.70141 19.3578C7.87432 20.3088 8.70258 21 9.66915 21H14.3308C15.2974 21 16.1257 20.3087 16.2986 19.3578L18 10"
                            stroke="#000000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                          <path
                            d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"
                            stroke="#000000"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                        </g>
                      </svg>
                    </button>
                    <button
                      class="flex items-center justify-center w-full ml-2 px-3 py-2 text-sm font-medium text-black bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-gray-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                      type="button"
                      @click="openUpdateContentModal(content._id)"
                    >
                      <svg
                        class="w-5 h-5 mr-2"
                        fill="#000000"
                        viewBox="0 0 32 32"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g
                          id="SVGRepo_bgCarrier"
                          stroke-width="0"
                        />
                        <g
                          id="SVGRepo_tracerCarrier"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="m16 0c8.836556 0 16 7.163444 16 16s-7.163444 16-16 16-16-7.163444-16-16 7.163444-16 16-16zm0 2c-7.7319865 0-14 6.2680135-14 14s6.2680135 14 14 14 14-6.2680135 14-14-6.2680135-14-14-14zm1.3 18.5v2.6h-2.6v-2.6zm-1.3-11.5c2.209139 0 4 1.790861 4 4 0 1.8636009-1.2744465 3.4295388-2.9993376 3.873812l-.0006624 2.126188h-2v-4h1c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2c-1.0543618 0-1.9181651.8158778-1.9945143 1.8507377l-.0054857.1492623h-2c0-2.209139 1.790861-4 4-4z"
                          />
                        </g>
                      </svg>
                      <span>Details</span>
                    </button>
                  </div>
                  <Modal
                    :is-visible="modals[`updateContent${content._id}`] || false"
                    :modal-id="`updateContent${content._id}`"
                    @update:is-visible="value => modals[`updateContent${content._id}`] = value"
                  >
                    <template #body>
                      <div class="p-4">
                        <div class="flex flex-col items-center justify-center">
                          <svg
                            class="w-52"
                            fill="none"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g
                              id="SVGRepo_bgCarrier"
                              stroke-width="0"
                            />
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <g id="SVGRepo_iconCarrier">
                              <path
                                d="M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z"
                                fill="#000000"
                                opacity="0.4"
                              />
                              <path
                                d="M19.0206 3.48016C17.0806 1.54016 15.1806 1.49016 13.1906 3.48016L11.9806 4.69016C11.8806 4.79016 11.8406 4.95016 11.8806 5.09016C12.6406 7.74016 14.7606 9.86016 17.4106 10.6202C17.4506 10.6302 17.4906 10.6402 17.5306 10.6402C17.6406 10.6402 17.7406 10.6002 17.8206 10.5202L19.0206 9.31016C20.0106 8.33016 20.4906 7.38016 20.4906 6.42016C20.5006 5.43016 20.0206 4.47016 19.0206 3.48016Z"
                                fill="#000000"
                                opacity="0.4"
                              />
                              <path
                                d="M15.6103 11.5298C15.3203 11.3898 15.0403 11.2498 14.7703 11.0898C14.5503 10.9598 14.3403 10.8198 14.1303 10.6698C13.9603 10.5598 13.7603 10.3998 13.5703 10.2398C13.5503 10.2298 13.4803 10.1698 13.4003 10.0898C13.0703 9.8098 12.7003 9.4498 12.3703 9.0498C12.3403 9.0298 12.2903 8.9598 12.2203 8.8698C12.1203 8.7498 11.9503 8.5498 11.8003 8.3198C11.6803 8.1698 11.5403 7.9498 11.4103 7.7298C11.2503 7.4598 11.1103 7.1898 10.9703 6.9098C10.8303 6.6098 10.7203 6.3198 10.6203 6.0498L4.34032 12.3298C4.21032 12.4598 4.09032 12.7098 4.06032 12.8798L3.52032 16.7098C3.42032 17.3898 3.61032 18.0298 4.03032 18.4598C4.39032 18.8098 4.89032 18.9998 5.43032 18.9998C5.55032 18.9998 5.67032 18.9898 5.79032 18.9698L9.63032 18.4298C9.81032 18.3998 10.0603 18.2798 10.1803 18.1498L16.4603 11.8698C16.1803 11.7698 15.9103 11.6598 15.6103 11.5298Z"
                                fill="#000000"
                              />
                            </g>
                          </svg>
                          <h2 class="block text-2xl font-bold text-gray-800 dark:text-gray-200">
                            Update Content
                          </h2>
                          <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
                            You are updating this content.
                          </p>
                        </div>
                        <div class="relative mt-6">
                          <input
                            id="newModuleTitle"
                            v-model="content.title"
                            class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2"
                            placeholder="Enter the content name"
                            type="text"
                          >
                          <label
                            class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500"
                            for="newModuleTitle"
                          >Content
                            title</label>
                        </div>
                        <div
                          v-if="content.type === 'video'"
                          class="relative mt-6"
                        >
                          <input
                            id="contentLength"
                            v-model="content.length"
                            class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2"
                            placeholder="Enter the content length in minute"
                            type="text"
                          >
                          <label
                            class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500"
                            for="contentLength"
                          >Content
                            length (min)</label>
                        </div>
                        <div
                          v-if="content.type === 'video'"
                          class="relative mt-6"
                        >
                          <textarea
                            v-model="content.description"
                            class="py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                            placeholder="Please describe this content..."
                            rows="3"
                            type="text"
                          />
                        </div>
                        <div
                          v-if="content.type === 'video'"
                          class="relative mt-6"
                        >
                          <input
                            accept="video/*"
                            class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary
              disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400
              dark:focus:ring-gray-600"
                            type="file"
                            @change="(event) => handleContentVideoUpload(event, content)"
                          >
                          <label
                            class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500"
                            for="newContentVideoUrl"
                          >Video
                            URL</label>
                        </div>
                        <div
                          v-if="content.type === 'video'"
                          class="mt-4"
                        >
                          <div
                            v-if="getContentVideoPreviewState(content._id).status === 'loading'"
                            class="text-xs text-gray-600"
                          >
                            Loading video preview...
                          </div>
                          <div
                            v-else-if="getContentVideoPreviewState(content._id).status === 'error'"
                            class="text-xs text-red-600"
                          >
                            {{ getContentVideoPreviewState(content._id).error }}
                          </div>
                          <div
                            v-else-if="getContentVideoPreviewState(content._id).status === 'ready'"
                            class="space-y-2"
                          >
                            <video
                              class="w-full rounded-lg border border-gray-200"
                              controls
                              :src="getContentVideoPreviewState(content._id).url"
                            />
                            <button
                              class="text-xs font-semibold text-red-600 hover:text-red-700"
                              type="button"
                              @click="removeContentVideo(content)"
                            >
                              Remove video
                            </button>
                          </div>
                        </div>
                        <div
                          v-if="content.type === 'video' && content.videoUrl"
                          class="mt-2 text-xs text-gray-600"
                        >
                          Current video: {{ formatVideoLabel(content.videoUrl) }}
                        </div>
                        <div
                          v-if="content.type === 'video'"
                          class="mt-3"
                        >
                          <div
                            v-if="getContentVideoUploadState(content._id).status === 'uploading'"
                            class="text-xs text-gray-600"
                          >
                            Uploading video... {{ getContentVideoUploadState(content._id).progress }}%
                          </div>
                          <div
                            v-else-if="getContentVideoUploadState(content._id).status === 'success'"
                            class="text-xs text-green-700"
                          >
                            Video uploaded successfully.
                          </div>
                          <div
                            v-else-if="getContentVideoUploadState(content._id).status === 'error'"
                            class="text-xs text-red-600"
                          >
                            {{ getContentVideoUploadState(content._id).error }}
                          </div>
                          <div
                            v-if="getContentVideoUploadState(content._id).status === 'uploading'"
                            class="mt-2 h-2 w-full rounded-full bg-gray-200"
                          >
                            <div
                              class="h-2 rounded-full bg-black transition-all"
                              :style="{ width: `${getContentVideoUploadState(content._id).progress}%` }"
                            />
                          </div>
                        </div>
                        <div
                          v-if="content.type === 'article'"
                          class="relative mt-4 mb-2"
                        >
                          <textarea
                            v-model="content.body"
                            class="py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                            placeholder="Please describe this module..."
                            rows="3"
                          />
                        </div>
                      </div>
                    </template>
                    <template #footer>
                      <div class="flex items-center">
                        <button
                          class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                          type="button"
                          @click="closeModal(`updateContent${content._id}`)"
                        >
                          Cancel
                        </button>
                        <button
                          class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                          type="button"
                          :disabled="getContentVideoUploadState(content._id).status === 'uploading'"
                          @click="updateContent(module._id,content)"
                        >
                          Update
                        </button>
                      </div>
                    </template>
                  </Modal>
                  <Modal
                    :is-visible="modals[`deleteContent${content._id}`] || false"
                    :modal-id="`deleteContent${content._id}`"
                    @update:is-visible="value => modals[`deleteContent${content._id}`] = value"
                  >
                    <template #body>
                      <div class="p-4 sm:p-10 overflow-y-auto">
                        <div class="flex gap-x-4 md:gap-x-7">
                          <span
                            class="flex-shrink-0 inline-flex justify-center items-center size-[46px] sm:w-[62px] sm:h-[62px] rounded-full border-4 border-red-50 bg-red-100 text-red-500 dark:bg-red-700 dark:border-red-600 dark:text-red-100"
                          > <svg
                            class="flex-shrink-0 size-5"
                            fill="currentColor"
                            height="16"
                            viewBox="0 0 16 16"
                            width="16"
                            xmlns="http://www.w3.org/2000/svg"
                          > <path
                            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                          /> </svg> </span>
                          <div class="grow">
                            <h3 class="mb-2 text-xl font-bold text-gray-800 dark:text-gray-200">
                              Delete Module Content
                            </h3>
                            <p class="text-gray-500">
                              Permanently remove the selected content and all its data from the course module.
                              This action cannot be undone.
                            </p>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #footer>
                      <div class="flex items-center">
                        <button
                          class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                          type="button"
                          @click="closeModal(`deleteContent${content._id}`)"
                        >
                          Cancel
                        </button>
                        <button
                          class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                          type="button"
                          @click="deleteContent(module._id, content._id)"
                        >
                          Delete
                        </button>
                      </div>
                    </template>
                  </Modal>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </draggable>
      <Modal
        v-for="(module, moduleIndex) in course.modules"
        :key="moduleIndex"
        :is-visible="modals[`newContent${module._id}`] || false"
        :modal-id="`newContent${module._id}`"
        @update:is-visible="value => modals[`newContent${module._id}`] = value"
      >
        <template #body>
          <div class="p-4">
            <div class="flex flex-col items-center justify-center">
              <svg
                class="w-52"
                fill="none"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  id="SVGRepo_bgCarrier"
                  stroke-width="0"
                />
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M15.5 13.15H13.33C11.55 13.15 10.1 11.71 10.1 9.92V7.75C10.1 7.34 9.77 7 9.35 7H6.18C3.87 7 2 8.5 2 11.18V17.82C2 20.5 3.87 22 6.18 22H12.07C14.38 22 16.25 20.5 16.25 17.82V13.9C16.25 13.48 15.91 13.15 15.5 13.15Z"
                    fill="#292D32"
                    opacity="0.4"
                  />
                  <path
                    d="M17.8198 2H15.8498H14.7598H11.9298C9.66977 2 7.83977 3.44 7.75977 6.01C7.81977 6.01 7.86977 6 7.92977 6H10.7598H11.8498H13.8198C16.1298 6 17.9998 7.5 17.9998 10.18V12.15V14.86V16.83C17.9998 16.89 17.9898 16.94 17.9898 16.99C20.2198 16.92 21.9998 15.44 21.9998 12.83V10.86V8.15V6.18C21.9998 3.5 20.1298 2 17.8198 2Z"
                    fill="#292D32"
                  />
                  <path
                    d="M11.9806 7.15024C11.6706 6.84024 11.1406 7.05024 11.1406 7.48024V10.1002C11.1406 11.2002 12.0706 12.1002 13.2106 12.1002C13.9206 12.1102 14.9106 12.1102 15.7606 12.1102C16.1906 12.1102 16.4106 11.6102 16.1106 11.3102C15.0206 10.2202 13.0806 8.27024 11.9806 7.15024Z"
                    fill="#292D32"
                  />
                </g>
              </svg>
              <h2 class="block text-2xl font-bold text-gray-800 dark:text-gray-200">
                Add New Content
              </h2>
              <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
                You are creating new content for this module.
              </p>
            </div>
            <div class="mt-6">
              <ul class="grid w-full gap-6 md:grid-cols-2">
                <li>
                  <input
                    id="content-video"
                    v-model="newContent.type"
                    class="hidden peer"
                    name="content-type"
                    required
                    type="radio"
                    value="video"
                  >
                  <label
                    class="inline-flex items-center justify-between w-full p-5 text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-gray-500 peer-checked:border-gray-600 peer-checked:text-gray-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700"
                    for="content-video"
                  >
                    <span class="block">
                      <span class="w-full text-lg font-semibold">Video</span>
                    </span>
                    <svg
                      aria-hidden="true"
                      class="w-5 h-5 ms-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 10l4.55-3.27A1 1 0 0121 7.76v8.48a1 1 0 01-1.45.87L15 14v2a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h8a2 2 0 012 2v2z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </svg>
                  </label>
                </li>
                <li>
                  <input
                    id="content-type-article"
                    v-model="newContent.type"
                    class="hidden peer"
                    name="content-type"
                    type="radio"
                    value="article"
                  >
                  <label
                    class="inline-flex items-center justify-between w-full p-5 text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer dark:hover:text-gray-300 dark:border-gray-700 dark:peer-checked:text-gray-500 peer-checked:border-gray-600 peer-checked:text-gray-600 hover:text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:bg-gray-800 dark:hover:bg-gray-700"
                    for="content-type-article"
                  >
                    <span class="block">
                      <span class="w-full text-lg font-semibold">Makale</span>
                    </span>
                    <svg
                      aria-hidden="true"
                      class="w-5 h-5 ms-3"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 3v18l7-3 7 3V3z"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </svg>
                  </label>
                </li>
              </ul>
            </div>
            <div class="relative mt-6">
              <input
                id="newModuleTitle"
                v-model="newContent.title"
                class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2"
                placeholder="Enter the content name"
                type="text"
              >
              <label
                class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500"
                for="newModuleTitle"
              >Content
                Title</label>
            </div>
            <div
              v-if="newContent.type === 'video'"
              class="relative mt-6"
            >
              <label
                class="sr-only"
                for="file-input"
              >Video File</label>
              <input
                id="file-input"
                accept="video/*"
                class="block w-full border border-gray-200 shadow-sm rounded-lg text-sm focus:z-10 focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400
    file:bg-gray-50 file:border-0
    file:me-4
    file:py-3 file:px-4
    dark:file:bg-neutral-700 dark:file:text-neutral-400"
                name="file-input"
                type="file"
                @change="handleVideoUpload"
              >
            </div>
            <div
              v-if="newContent.type === 'video'"
              class="mt-4"
            >
              <div
                v-if="newVideoPreview.status === 'loading'"
                class="text-xs text-gray-600"
              >
                Loading video preview...
              </div>
              <div
                v-else-if="newVideoPreview.status === 'error'"
                class="text-xs text-red-600"
              >
                {{ newVideoPreview.error }}
              </div>
              <div
                v-else-if="newVideoPreview.status === 'ready'"
                class="space-y-2"
              >
                <video
                  class="w-full rounded-lg border border-gray-200"
                  controls
                  :src="newVideoPreview.url"
                />
                <button
                  class="text-xs font-semibold text-red-600 hover:text-red-700"
                  type="button"
                  @click="removeNewVideo"
                >
                  Remove video
                </button>
              </div>
            </div>
            <div
              v-if="newContent.type === 'video'"
              class="mt-3"
            >
              <div
                v-if="newVideoUpload.status === 'uploading'"
                class="text-xs text-gray-600"
              >
                Uploading video... {{ newVideoUpload.progress }}%
              </div>
              <div
                v-else-if="newVideoUpload.status === 'success'"
                class="text-xs text-green-700"
              >
                Video uploaded successfully.
              </div>
              <div
                v-else-if="newVideoUpload.status === 'error'"
                class="text-xs text-red-600"
              >
                {{ newVideoUpload.error }}
              </div>
              <div
                v-if="newVideoUpload.status === 'uploading'"
                class="mt-2 h-2 w-full rounded-full bg-gray-200"
              >
                <div
                  class="h-2 rounded-full bg-black transition-all"
                  :style="{ width: `${newVideoUpload.progress}%` }"
                />
              </div>
            </div>
            <div class="relative mt-6">
              <input
                id="contentLength"
                v-model="newContent.length"
                class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2"
                placeholder="Enter the content length in minute"
                type="text"
              >
              <label
                class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500"
                for="contentLength"
              >Content
                length (min)</label>
            </div>
            <div class="relative mt-4 mb-2">
              <textarea
                v-model="newContent.description"
                class="py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                placeholder="Please describe this content..."
                rows="3"
                type="text"
              />
            </div>
            <div
              v-if="newContent.type === 'article'"
              class="relative mt-4 mb-2"
            >
              <textarea
                v-model="newContent.body"
                class="py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                placeholder="Please describe this content..."
                rows="3"
              />
            </div>
          </div>
        </template>
        <template #footer>
          <div class="flex items-center">
            <button
              class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              type="button"
              @click="closeModal(`newContent${module._id}`)"
            >
              Cancel
            </button>
            <button
              class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              type="button"
              :disabled="newVideoUpload.status === 'uploading'"
              @click="createContent"
            >
              Create
            </button>
          </div>
        </template>
      </Modal>
      <Modal
        v-for="(module, index) in course.modules"
        :key="index"
        :is-visible="modals[`updateModule${module._id}`] || false"
        :modal-id="`updateModule${module._id}`"
        @update:is-visible="value => modals[`updateModule${module._id}`] = value"
      >
        <template #body>
          <div class="p-4">
            <div class="flex flex-col items-center justify-center">
              <svg
                class="w-52"
                fill="none"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  id="SVGRepo_bgCarrier"
                  stroke-width="0"
                />
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z"
                    fill="#000000"
                    opacity="0.4"
                  />
                  <path
                    d="M19.0206 3.48016C17.0806 1.54016 15.1806 1.49016 13.1906 3.48016L11.9806 4.69016C11.8806 4.79016 11.8406 4.95016 11.8806 5.09016C12.6406 7.74016 14.7606 9.86016 17.4106 10.6202C17.4506 10.6302 17.4906 10.6402 17.5306 10.6402C17.6406 10.6402 17.7406 10.6002 17.8206 10.5202L19.0206 9.31016C20.0106 8.33016 20.4906 7.38016 20.4906 6.42016C20.5006 5.43016 20.0206 4.47016 19.0206 3.48016Z"
                    fill="#000000"
                    opacity="0.4"
                  />
                  <path
                    d="M15.6103 11.5298C15.3203 11.3898 15.0403 11.2498 14.7703 11.0898C14.5503 10.9598 14.3403 10.8198 14.1303 10.6698C13.9603 10.5598 13.7603 10.3998 13.5703 10.2398C13.5503 10.2298 13.4803 10.1698 13.4003 10.0898C13.0703 9.8098 12.7003 9.4498 12.3703 9.0498C12.3403 9.0298 12.2903 8.9598 12.2203 8.8698C12.1203 8.7498 11.9503 8.5498 11.8003 8.3198C11.6803 8.1698 11.5403 7.9498 11.4103 7.7298C11.2503 7.4598 11.1103 7.1898 10.9703 6.9098C10.8303 6.6098 10.7203 6.3198 10.6203 6.0498L4.34032 12.3298C4.21032 12.4598 4.09032 12.7098 4.06032 12.8798L3.52032 16.7098C3.42032 17.3898 3.61032 18.0298 4.03032 18.4598C4.39032 18.8098 4.89032 18.9998 5.43032 18.9998C5.55032 18.9998 5.67032 18.9898 5.79032 18.9698L9.63032 18.4298C9.81032 18.3998 10.0603 18.2798 10.1803 18.1498L16.4603 11.8698C16.1803 11.7698 15.9103 11.6598 15.6103 11.5298Z"
                    fill="#000000"
                  />
                </g>
              </svg>
              <h2 class="block text-2xl font-bold text-gray-800 dark:text-gray-200">
                Update Module
              </h2>
              <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
                You are updating this module.
              </p>
            </div>
            <div class="relative mt-6">
              <input
                id="updateModuleTitle"
                v-model="module.title"
                class="peer p-4 block w-full border border-gray-200 rounded-lg text-sm placeholder:text-transparent focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 focus:pt-6 focus:pb-2 [&:not(:placeholder-shown)]:pt-6 [&:not(:placeholder-shown)]:pb-2 autofill:pt-6 autofill:pb-2"
                placeholder="Enter the module name"
                type="text"
              >
              <label
                class="absolute top-0 start-0 p-4 h-full text-sm truncate pointer-events-none transition ease-in-out duration-100 border border-transparent dark:text-white peer-disabled:opacity-50 peer-disabled:pointer-events-none peer-focus:text-xs peer-focus:-translate-y-1.5 peer-focus:text-gray-500 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:-translate-y-1.5 peer-[:not(:placeholder-shown)]:text-gray-500"
                for="updateModuleTitle"
              >Module
                title</label>
            </div>
            <div class="relative mt-4 mb-2">
              <textarea
                v-model="module.description"
                class="py-3 px-4 block w-full border border-gray-200 rounded-lg text-sm focus:border-primary focus:ring-primary disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 dark:focus:ring-gray-600"
                placeholder="Please describe this module..."
                rows="3"
                type="text"
              />
            </div>
          </div>
        </template>
        <template #footer>
          <div class="flex items-center">
            <button
              class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              type="button"
              @click="closeModal(`updateModule${module._id}`)"
            >
              Cancel
            </button>
            <button
              class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-black text-white hover:bg-gray-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              type="button"
              @click="updateModule(module)"
            >
              Update
            </button>
          </div>
        </template>
      </Modal>
      <Modal
        v-for="(module, index) in course.modules"
        :key="index"
        :is-visible="modals[`deleteModule${module._id}`] || false"
        :modal-id="`deleteModule${module._id}`"
        @update:is-visible="value => modals[`deleteModule${module._id}`] = value"
      >
        <template #body>
          <div class="p-4 sm:p-10 overflow-y-auto">
            <div class="flex gap-x-4 md:gap-x-7">
              <span
                class="flex-shrink-0 inline-flex justify-center items-center size-[46px] sm:w-[62px] sm:h-[62px] rounded-full border-4 border-red-50 bg-red-100 text-red-500 dark:bg-red-700 dark:border-red-600 dark:text-red-100"
              > <svg
                class="flex-shrink-0 size-5"
                fill="currentColor"
                height="16"
                viewBox="0 0 16 16"
                width="16"
                xmlns="http://www.w3.org/2000/svg"
              > <path
                d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
              /> </svg> </span>
              <div class="grow">
                <h3 class="mb-2 text-xl font-bold text-gray-800 dark:text-gray-200">
                  Delete Course Module
                </h3>
                <p class="text-gray-500">
                  Permanently remove the selected module and all its content from the course.
                  This action cannot be undone.
                </p>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="flex items-center">
            <button
              class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-es-xl border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:hover:bg-white/20 dark:text-white dark:hover:text-white dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              type="button"
              @click="closeModal(`deleteModule${module._id}`)"
            >
              Cancel
            </button>
            <button
              class="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-ee-xl border border-transparent bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:pointer-events-none dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
              type="button"
              @click="deleteModule(module._id)"
            >
              Delete
            </button>
          </div>
        </template>
      </Modal>
    </div>
  </section>
</template>
<script lang="ts">
import {defineComponent, watchEffect} from 'vue';
import {useRouter} from 'vue-router';
import axios from 'axios';
import {VueDraggableNext} from 'vue-draggable-next';
import Modal from '@/components/Modal.vue';
import {Content, Course, Module} from '@/types';
import {useHead} from "@vueuse/head";

interface ComponentData {
  enabled: boolean;
  course: Course;
  newModule: {
    title: string;
    description: string;
  };
  newContent: {
    type: string;
    title: string;
    description: string;
    body: string;
    videoUrl: string;
    length: number;
  };
  loading: boolean;
  error: string | null;
  dragging: boolean;
  modals: Record<string, boolean>;
  selectedModuleId?: string;
  newVideoUpload: UploadState;
  newVideoPreview: VideoPreviewState;
  videoUploadByContentId: Record<string, UploadState>;
  videoPreviewByContentId: Record<string, VideoPreviewState>;
}

interface UploadState {
  status: 'idle' | 'uploading' | 'success' | 'error';
  progress: number;
  error: string | null;
}

interface VideoPreviewState {
  status: 'idle' | 'loading' | 'ready' | 'error';
  url: string;
  error: string | null;
}

export default defineComponent({
  name: "Course",
  components: {
    Modal,
    draggable: VueDraggableNext,
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup() {
    const router = useRouter();
    return {router};
  },
  data(): ComponentData {
    return {
      enabled: true,
      course: {} as Course,
      newModule: {
        title: '',
        description: ''
      },
      newContent: {
        type: 'video',
        title: '',
        description: '',
        body: '',
        videoUrl: '',
        length: 0
      },
      loading: false,
      error: null,
      dragging: false,
      newVideoUpload: {
        status: 'idle',
        progress: 0,
        error: null
      },
      newVideoPreview: {
        status: 'idle',
        url: '',
        error: null
      },
      videoUploadByContentId: {},
      videoPreviewByContentId: {},
      modals: {
        newModule: false,
        newContent: false
      },
    };
  },
  async mounted() {
    this.loading = true;
    try {
      const response = await axios.get<Course>(`course/detail/${this.id}`);
      this.course = response.data;

      watchEffect(() => {
        useHead({
          title: this.course.title,
        });
      });

      if (this.course.modules) {
        this.course.modules.forEach(module => {
          module.show = false;
        });
      }
    } catch (err) {
      console.error(err);
      this.error = "An error occurred while fetching the course.";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    openModal(modalId: string): void {
      this.modals[modalId] = true;
    },
    closeModal(modalId: string): void {
      this.modals[modalId] = false;
    },
    openNewContentModal(moduleId: string): void {
      this.openModal(`newContent${moduleId}`);
      this.selectedModuleId = moduleId;
      this.resetNewVideoUpload();
      this.resetNewVideoPreview();
    },
    openUpdateModuleModal(moduleId: string): void {
      this.openModal(`updateModule${moduleId}`);
      this.selectedModuleId = moduleId;
    },
    openDeleteModuleModal(moduleId: string): void {
      this.openModal(`deleteModule${moduleId}`);
      this.selectedModuleId = moduleId;
    },
    openUpdateContentModal(contentId: string): void {
      this.openModal(`updateContent${contentId}`);
      this.resetContentVideoUpload(contentId);
      const module = this.course.modules?.find(mod =>
        mod.contents?.some(content => content._id === contentId)
      );
      const content = module?.contents?.find(item => item._id === contentId);
      if (content) {
        this.loadContentVideoPreview(content);
      }
    },
    openDeleteContentModal(contentId: string): void {
      this.openModal(`deleteContent${contentId}`);
    },
    orderModules(): void {
      this.course.modules?.forEach((module, index) => {
        module.order = index;
      });
      this.updateModulesOrder();
    },
    orderContents(module: Module): void {
      const clonedContents = [...(module.contents || [])];
      clonedContents.forEach((content, index) => {
        content.order = index;
      });
      this.updateContentsOrder(module);
    },
    async createModule(): Promise<void> {
      try {
        const courseId = this.course._id;
        const response = await axios.post<{ course: Course }>(
            `/course/${courseId}/module`,
            this.newModule
        );

        this.course = response.data.course;
        this.closeModal('newModule');
        this.newModule = {title: '', description: ''};
      } catch (error) {
        console.error('Failed to create module:', error);
      }
    },
    async createContent(): Promise<void> {
      const courseId = this.course._id;
      const moduleId = this.selectedModuleId;
      if (!moduleId) return;

      try {
        const response = await axios.post<{ course: Course }>(
            `/course/${courseId}/${moduleId}/content`,
            this.newContent
        );

        const moduleIndex = this.course.modules?.findIndex(m => m._id === moduleId) ?? -1;
        if (moduleIndex !== -1) {
          const newContent = response.data.course.modules?.[moduleIndex]?.contents?.slice(-1)[0];
          if (newContent) {
            this.course.modules[moduleIndex].contents?.push(newContent);
          }
        }

        this.newContent = {
          type: 'video',
          title: '',
          description: '',
          body: '',
          videoUrl: '',
          length: 0
        };
        this.resetNewVideoUpload();
        this.resetNewVideoPreview();

        this.closeModal(`newContent${moduleId}`);
      } catch (error) {
        console.error('Failed to add content:', error);
      }
    },
    async updateModule(module: Module): Promise<void> {
      try {
        await axios.put(`/course/update-module/${this.course._id}/${module._id}`, module);
        this.closeModal(`updateModule${module._id}`);
      } catch (error) {
        console.error('Failed to update module:', error);
      }
    },
    async updateModulesOrder(): Promise<void> {
      const courseId = this.course._id;
      const moduleOrder = this.course.modules?.map((module, index) => ({
        id: module._id,
        order: index
      })) || [];

      try {
        await axios.post('/course/update-module-order', {moduleOrder, courseId});
      } catch (error) {
        console.error('Failed to update module order:', error);
      }
    },
    async deleteModule(moduleId: string): Promise<void> {
      try {
        await axios.delete(`/course/delete-module/${this.course._id}/${moduleId}`);
        this.course.modules = this.course.modules?.filter(m => m._id !== moduleId) || [];
      } catch (error) {
        console.error('Failed to delete module:', error);
      }
    },
    async updateContent(moduleId: string, content: Content): Promise<void> {
      try {
        await axios.put(`/course/update-module-content/${this.course._id}/${moduleId}/${content._id}`, content);
        this.closeModal(`updateContent${content._id}`);
      } catch (error) {
        console.error('Failed to update content:', error);
      }
    },
    async updateContentsOrder(module: Module): Promise<void> {
      const courseId = this.course._id;
      const moduleId = module._id;
      const contentOrder = module.contents?.map((content, index) => ({
        id: content._id,
        order: index
      })) || [];

      try {
        await axios.post('/course/update-module-content-order', {contentOrder, moduleId, courseId});
      } catch (error) {
        console.error('Failed to update content order:', error);
      }
    },
    async deleteContent(moduleId: string, contentId: string): Promise<void> {
      try {
        await axios.delete(`/course/delete-content/${this.course._id}/${moduleId}/${contentId}`);
        const moduleIndex = this.course.modules?.findIndex(m => m._id === moduleId) ?? -1;
        if (moduleIndex !== -1) {
          this.course.modules[moduleIndex].contents =
              this.course.modules[moduleIndex].contents?.filter(c => c._id !== contentId) || [];
        }
      } catch (error) {
        console.error('Failed to delete content:', error);
      }
    },
    toggleModule(module: Module): void {
      module.show = !module.show;
    },
    getContentCount(module: Module): string {
      let videoCount = 0;
      let documentCount = 0;

      module.contents?.forEach(content => {
        switch (content.type) {
          case 'video':
            videoCount++;
            break;
          case 'article':
            documentCount++;
            break;
        }
      });

      return `${videoCount} Videos, ${documentCount} Documents`;
    },
    async handleVideoUpload(event: Event): Promise<void> {
      await this.handleNewVideoUpload(event);
    },
    async handleNewVideoUpload(event: Event): Promise<void> {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      if (!file) return;

      this.newVideoUpload = {
        status: 'uploading',
        progress: 0,
        error: null
      };

      const formData = new FormData();
      formData.append("video", file);

      try {
        const response = await axios.post<{ videoUrl: string }>('/upload/video', formData, {
          onUploadProgress: (progressEvent) => {
            const total = progressEvent.total || 0;
            const percent = total ? Math.round((progressEvent.loaded / total) * 100) : 0;
            this.newVideoUpload = {
              status: 'uploading',
              progress: percent,
              error: null
            };
          }
        });
        this.newContent.videoUrl = response.data.videoUrl;
        this.newVideoUpload = {
          status: 'success',
          progress: 100,
          error: null
        };
        await this.loadNewVideoPreview();
      } catch (error) {
        console.error("Failed to upload video:", error);
        this.newVideoUpload = {
          status: 'error',
          progress: 0,
          error: 'Video upload failed. Please try again.'
        };
      }
    },
    async loadNewVideoPreview(): Promise<void> {
      if (!this.newContent.videoUrl) {
        this.resetNewVideoPreview();
        return;
      }

      this.newVideoPreview = {
        status: 'loading',
        url: '',
        error: null
      };

      try {
        const response = await axios.get<{ url: string }>(
          `/video/get-signed-url?fileName=${encodeURIComponent(this.newContent.videoUrl)}`
        );
        this.newVideoPreview = {
          status: 'ready',
          url: response.data.url,
          error: null
        };
      } catch (error) {
        console.error('Failed to load new video preview:', error);
        this.newVideoPreview = {
          status: 'error',
          url: '',
          error: 'Failed to load video preview.'
        };
      }
    },
    removeNewVideo(): void {
      this.newContent.videoUrl = '';
      this.resetNewVideoPreview();
    },
    resetNewVideoPreview(): void {
      this.newVideoPreview = {
        status: 'idle',
        url: '',
        error: null
      };
    },
    async handleContentVideoUpload(event: Event, content: Content): Promise<void> {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      if (!file) return;

      this.setContentVideoUploadState(content._id, {
        status: 'uploading',
        progress: 0,
        error: null
      });

      const formData = new FormData();
      formData.append("video", file);

      try {
        const response = await axios.post<{ videoUrl: string }>('/upload/video', formData, {
          onUploadProgress: (progressEvent) => {
            const total = progressEvent.total || 0;
            const percent = total ? Math.round((progressEvent.loaded / total) * 100) : 0;
            this.setContentVideoUploadState(content._id, {
              status: 'uploading',
              progress: percent,
              error: null
            });
          }
        });
        content.videoUrl = response.data.videoUrl;
        this.setContentVideoUploadState(content._id, {
          status: 'success',
          progress: 100,
          error: null
        });
        await this.loadContentVideoPreview(content);
      } catch (error) {
        console.error("Failed to upload video:", error);
        this.setContentVideoUploadState(content._id, {
          status: 'error',
          progress: 0,
          error: 'Video upload failed. Please try again.'
        });
      }
    },
    async loadContentVideoPreview(content: Content): Promise<void> {
      if (!content.videoUrl) {
        this.videoPreviewByContentId = {
          ...this.videoPreviewByContentId,
          [content._id]: {
            status: 'idle',
            url: '',
            error: null
          }
        };
        return;
      }

      this.videoPreviewByContentId = {
        ...this.videoPreviewByContentId,
        [content._id]: {
          status: 'loading',
          url: '',
          error: null
        }
      };

      try {
        const response = await axios.get<{ url: string }>(
          `/video/get-signed-url?fileName=${encodeURIComponent(content.videoUrl)}`
        );
        this.videoPreviewByContentId = {
          ...this.videoPreviewByContentId,
          [content._id]: {
            status: 'ready',
            url: response.data.url,
            error: null
          }
        };
      } catch (error) {
        console.error('Failed to load video preview:', error);
        this.videoPreviewByContentId = {
          ...this.videoPreviewByContentId,
          [content._id]: {
            status: 'error',
            url: '',
            error: 'Failed to load video preview.'
          }
        };
      }
    },
    removeContentVideo(content: Content): void {
      content.videoUrl = '';
      this.videoPreviewByContentId = {
        ...this.videoPreviewByContentId,
        [content._id]: {
          status: 'idle',
          url: '',
          error: null
        }
      };
    },
    getContentVideoPreviewState(contentId: string): VideoPreviewState {
      return this.videoPreviewByContentId[contentId] || {
        status: 'idle',
        url: '',
        error: null
      };
    },
    getContentVideoUploadState(contentId: string): UploadState {
      return this.videoUploadByContentId[contentId] || {
        status: 'idle',
        progress: 0,
        error: null
      };
    },
    setContentVideoUploadState(contentId: string, state: UploadState): void {
      this.videoUploadByContentId = {
        ...this.videoUploadByContentId,
        [contentId]: state
      };
    },
    resetContentVideoUpload(contentId: string): void {
      this.setContentVideoUploadState(contentId, {
        status: 'idle',
        progress: 0,
        error: null
      });
    },
    resetNewVideoUpload(): void {
      this.newVideoUpload = {
        status: 'idle',
        progress: 0,
        error: null
      };
    },
    formatVideoLabel(videoUrl: string): string {
      const trimmed = videoUrl.trim();
      if (!trimmed) return 'No video attached';
      const lastSegment = trimmed.split('/').pop() || trimmed;
      const sanitized = lastSegment.split('?')[0] || lastSegment;
      return sanitized;
    },
  },
});
</script>
